import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const setExtDataCategory = (payload) => ({
  type: actionTypes.SET_EXT_DATA_CATEGORY,
  payload
});

export const getExtDataCategories = (params) => ({
  type: actionTypes.GET_EXT_DATA_CATEGORIES,
  params
});

export const getExtDataCategory = (id) => ({
  type: actionTypes.GET_EXT_DATA_CATEGORY,
  id
});

export const createExtDataCategory = (payload) => ({
  type: actionTypes.CREATE_EXT_DATA_CATEGORY,
  payload
});

export const updateExtDataCategory = (payload) => ({
  type: actionTypes.UPDATE_EXT_DATA_CATEGORY,
  payload,
});

export const deleteExtDataCategory = (Id) => ({
  type: actionTypes.DELETE_EXT_DATA_CATEGORY,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});


export const setOpenModal = (isOpen) => ({
  type: actionTypes.SET_OPEN_MODAL,
  payload: isOpen,
});

export const updateExtDataCategoriesOrder = (orderData) => ({
    type: actionTypes.UPDATE_EXT_DATA_CATEGORIES_ORDER,
    payload: { orderData }
});